import { AnalyticsEventName } from '@dupe/common/constants'
import { motion } from 'framer-motion'
import Button from '~/src/components/Button'
import OnboardingTitle from '~/src/components/onboarding/OnboardingTitle'
import useAnalytics from '~/src/hooks/useAnalytics'
import {
  OnboardingStep,
  useOnboardingActions,
} from '~/src/stores/useOnboardingStore'

const comparisonData = {
  own: {
    title: 'Savings on your own',
    percentage: '10%',
  },
  dupe: {
    title: 'Savings with Dupe.com',
    percentage: '50%+',
  },
}

const DupeValuePropOneStep: React.FC = () => {
  const analytics = useAnalytics()

  const nextStep = useOnboardingActions().nextStep
  const markStepComplete = useOnboardingActions().markStepComplete

  const handleContinue = async () => {
    analytics.track(AnalyticsEventName.AuthModalOnboardingSubmit, {
      step: 'value-prop-one',
    })

    markStepComplete(OnboardingStep.DUPE_VALUE_PROP_ONE)
    nextStep(OnboardingStep.JOB_TO_BE_DONE)
  }

  return (
    <div className='space-y-8 md:space-y-10'>
      <OnboardingTitle
        title='Dupe was designed to find you huge savings, fast.'
        description='Millions of datapoints show we save users 5X more than coupon apps or search engines in half the time.'
      />
      <div className='mx-auto grid max-w-[260px] grid-cols-2 items-center gap-4 px-6 md:max-w-xs'>
        {Object.entries(comparisonData).map(([key, data]) => (
          <div key={key}>
            <div className='mx-auto mb-4 w-[100px] text-center font-medium'>
              {data.title}
            </div>
            <div className='relative h-[25dvh] rounded-md bg-[#f2f9f2] md:h-[200px]'>
              <motion.div
                initial={{ height: 0 }}
                animate={{ height: key === 'own' ? '45px' : '55%' }}
                transition={{ delay: 0.3 }}
                className={`absolute bottom-0 w-full ${
                  key === 'own'
                    ? 'bg-[#34C759]'
                    : 'bg-gradient-to-b from-[#33CD5A] to-[#6DEE8D]'
                } flex items-start justify-center rounded-md`}
              >
                <div className='p-2.5 text-lg font-bold text-white'>
                  {data.percentage}
                </div>
              </motion.div>
            </div>
          </div>
        ))}
      </div>
      <Button onClick={() => handleContinue()} fullWidth>
        Continue
      </Button>
    </div>
  )
}

export default DupeValuePropOneStep
